import { useSelector } from 'react-redux';

/**
 * Returns the ownerOrgId of the current user.
 * @returns {string}
 */
const useOwnerOrgId = () =>
  useSelector((state) => state.authentication?.ownerOrgId);

export default useOwnerOrgId;
